/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateAddressDto } from './CreateAddressDto';
import {
    CreateAddressDtoFromJSON,
    CreateAddressDtoFromJSONTyped,
    CreateAddressDtoToJSON,
    CreateAddressDtoToJSONTyped,
} from './CreateAddressDto';

/**
 * 
 * @export
 * @interface UpdateRealEstateCommandDto
 */
export interface UpdateRealEstateCommandDto {
    /**
     * 
     * @type {CreateAddressDto}
     * @memberof UpdateRealEstateCommandDto
     */
    address: CreateAddressDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateRealEstateCommandDto
     */
    personId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRealEstateCommandDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateRealEstateCommandDto
     */
    area: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRealEstateCommandDto
     */
    roomCount: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRealEstateCommandDto
     */
    monthlyRent?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRealEstateCommandDto
     */
    charges?: number;
    /**
     * 
     * @type {Blob}
     * @memberof UpdateRealEstateCommandDto
     */
    photo?: Blob;
    /**
     * 
     * @type {number}
     * @memberof UpdateRealEstateCommandDto
     */
    propertyType: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRealEstateCommandDto
     */
    rentalType?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRealEstateCommandDto
     */
    photoHasChanged: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateRealEstateCommandDto
     */
    riskId?: string;
}

/**
 * Check if a given object implements the UpdateRealEstateCommandDto interface.
 */
export function instanceOfUpdateRealEstateCommandDto(value: object): value is UpdateRealEstateCommandDto {
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('personId' in value) || value['personId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('area' in value) || value['area'] === undefined) return false;
    if (!('roomCount' in value) || value['roomCount'] === undefined) return false;
    if (!('propertyType' in value) || value['propertyType'] === undefined) return false;
    if (!('photoHasChanged' in value) || value['photoHasChanged'] === undefined) return false;
    return true;
}

export function UpdateRealEstateCommandDtoFromJSON(json: any): UpdateRealEstateCommandDto {
    return UpdateRealEstateCommandDtoFromJSONTyped(json, false);
}

export function UpdateRealEstateCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRealEstateCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'address': CreateAddressDtoFromJSON(json['address']),
        'personId': json['personId'],
        'name': json['name'],
        'area': json['area'],
        'roomCount': json['roomCount'],
        'monthlyRent': json['monthlyRent'] == null ? undefined : json['monthlyRent'],
        'charges': json['charges'] == null ? undefined : json['charges'],
        'photo': json['photo'] == null ? undefined : json['photo'],
        'propertyType': json['propertyType'],
        'rentalType': json['rentalType'] == null ? undefined : json['rentalType'],
        'photoHasChanged': json['photoHasChanged'],
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
    };
}

export function UpdateRealEstateCommandDtoToJSON(json: any): UpdateRealEstateCommandDto {
    return UpdateRealEstateCommandDtoToJSONTyped(json, false);
}

export function UpdateRealEstateCommandDtoToJSONTyped(value?: UpdateRealEstateCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': CreateAddressDtoToJSON(value['address']),
        'personId': value['personId'],
        'name': value['name'],
        'area': value['area'],
        'roomCount': value['roomCount'],
        'monthlyRent': value['monthlyRent'],
        'charges': value['charges'],
        'photo': value['photo'],
        'propertyType': value['propertyType'],
        'rentalType': value['rentalType'],
        'photoHasChanged': value['photoHasChanged'],
        'riskId': value['riskId'],
    };
}

